/*
 * Initializes common helpers for our Backbone models, collections and views.
 *
 * @author Jonathon McDonald <jonathon@agencyfusion.com>
 * @author Rachel Wolthuis <rachel@agencyfusion.com>
 */

/**
 * The ProductHelper loads in missing data when fetching products via JSON
 * endpoints.
 */
var ProductHelper = {
  setImporantDetails: function (product) {
    var variants = product.get('variants');

    // Check to see if a url is set, set one if not.
    if (!product.get('url')) {
      product.set('url', '/products/' + product.get('handle'));
    }

    var currentPrice = 0;
    _.each(variants, function (variant) {
      var variantPrice = parseFloat(variant.price);

      // Set a price.
      if (variantPrice > currentPrice) {
        currentPrice = variantPrice;
        product.set('price', variantPrice * 100);
      }

      // Set availability boolean.
      if (variant.available) {
        product.set('available', true);
      }

      product.set('incomplete-attributes', true);
    });
  }
};

/**
 * The VariantPunett is a helper object that takes a product on construction.
 *
 * Use for constructing select boxes for variants, and managing variants for a
 * product.  Also useful for getting things like the values for a given variant
 * id.
 */
var VariantPunnett = function (product) {
  this.variants = product.get('variants');
  this.options = product.get('options');

  this.optionValueHash = [];
  this.variantCombos = [];

  /* Initializes and option value hash for variants. */
  this.initOptionValueHash = function (option) {
    if (typeof option === 'object') {
      this.optionValueHash.push({ option: option.name, values: [] });
    } else {
      this.optionValueHash.push({ option: option, values: [] });
    }
  };

  /* Loads all variants into the option value hash, and the variant combos. */
  this.loadVariants = function (variant) {
    var values = variant.options,
      variantCombo = {
        id: variant.id,
        values: [],
        price: variant.price,
        quantity: variant.inventory_quantity
      };

    _.each(values, function (value, index) {
        variantCombo.values.push(value);
        if (this.optionValueHash[index].values.indexOf(value) < 0) {
          this.optionValueHash[index].values.push(value);
        }
      }, this);
    this.variantCombos.push(variantCombo);
  }

  _.each(this.options, this.initOptionValueHash, this);
  _.each(this.variants, this.loadVariants, this);

  /* Returns a variant id using the provided options.  Zero for no match. */
  VariantPunnett.prototype.getId = function (option1, option2, option3) {
    var selectedOptions = [],
      combo = undefined,
      predicate = function (combo) {
        return _.difference(combo.values, selectedOptions).length == 0
      },
      loadIntoArr = function (arr, item) {
        if (item) {
          arr.push(item);
        }

        return arr;
      };

    selectedOptions = loadIntoArr(selectedOptions, option1);
    selectedOptions = loadIntoArr(selectedOptions, option2);
    selectedOptions = loadIntoArr(selectedOptions, option3);

    combo = _.find(this.variantCombos, predicate, this);
    if (combo) {
      return combo.id;
    }
  };

  /* Gets a hash of all options with their values. */
  VariantPunnett.prototype.getOptionsWithValues = function () {
    return this.optionValueHash;
  };

  /* Gets all options associated with a product variant based on its id. */
  VariantPunnett.prototype.getOptionsForVariant = function (id) {
    var variant = _.findWhere(this.variantCombos, { id: id });

    optionWithValues = [];
    if (variant) {
      _.each(variant.values, function (item, index) {
        var hash = {
          option: this.options[index].name,
          variant: item
        };

        optionWithValues.push(hash);
      }, this);
    }

    return optionWithValues;
  };

  /* Returns the quantity available for a given variant. */
  VariantPunnett.prototype.getQuantityForVariant = function (id) {
    var variant = _.findWhere(this.variantCombos, { id: id });

    if (variant) {
      return variant.quantity;
    }

    return 0;
  };

  /* Returns the price for a given variant. */
  VariantPunnett.prototype.getPriceForVariant = function (id) {
    var variant = _.findWhere(this.variantCombos, { id: id });
    if (variant) {
      return variant.price;
    }

    return undefined;
  };
};


/**
 * The Foreman is used to fetch products in an async fashion.  Loading products
 * should be done with:
 *
 * Foreman.fetch('sleep');
 * Foreman.on('load:products', function (products) { // Do something. });
 */
var Foreman = {
  call: function (page) {
    var fixedUrl = this.url + '?page=' + page;

    $.ajax({
      context: this,
      url: fixedUrl,
      success: this.successful
    });
  },

  fetch: function (url) {
    this.url = url;
    this.page = 1;
    this.call(this.page);
  },

  successful: function (data, text, xhr) {
    this.products = this.products || new App.Collections.Products();

    _.each(data.products, function (product) {
      // Avoid adding a product in the global collection
      if (App.ActiveCollections.Products.get(product.id)) {
        return;
      }

      var model = this.products.add(product);
      App.Helpers.ProductHelper.setImporantDetails(model);
    }, this);

    if (data.products.length >= 30 || data.products.length == 0) {
      this.call(this.page++);
    } else {
      console.log(this.products);
      this.trigger('products:loaded', this.products);
    }
  }
};

_.extend(Foreman, Backbone.Events);

window.App.Helpers = {};
window.App.Helpers.VariantPunnett = VariantPunnett;
window.App.Helpers.Foreman = Foreman;
window.App.Helpers.ProductHelper = ProductHelper;
